import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table table-striped my-4" }
const _hoisted_2 = { class: "thead-dark" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", { class: "d-lg-none" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.occupancyReport.timeSlot')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.occupancyReport.absolute.' + _ctx.reportType)), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.occupancyReport.capacity')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.occupancyReport.percentage.' + _ctx.reportType)), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportItems, (reportItem, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(_ctx.formatDay(reportItem)) + " ", 1),
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(reportItem)), 1)
          ]),
          _createElementVNode("td", null, _toDisplayString(reportItem.count), 1),
          _createElementVNode("td", null, _toDisplayString(reportItem.capacity), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.formatPercentage(reportItem)), 1)
        ]))
      }), 128))
    ])
  ]))
}